import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Stack } from '@src/types/Stacks';

interface UseGetStackByIdProps {
  id: string;
  enabled?: boolean;
}

export default ({ id, enabled = true }: UseGetStackByIdProps) =>
  useApiQuery<Stack>({
    queryKey: [QueryKeys.stacks, id],
    apiPath: `/stacks/${id}`,
    method: 'GET',
    useV2API: true,
    enabled,
  });
